module.exports = "/*!\n * jQuery UI Autocomplete 1.13.3\n * https://jqueryui.com\n *\n * Copyright OpenJS Foundation and other contributors\n * Released under the MIT license.\n * https://jquery.org/license\n *\n * https://api.jqueryui.com/autocomplete/#theming\n */\n.ui-autocomplete {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tcursor: default;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/jquery-ui/themes/base/autocomplete.css
// module id = 456
// module chunks = 0